import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { LIGHT_GREY, LIGHT_BLACK } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  rootActions: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(4),
  },
  rootContent: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(3, 2),
  },
  rootCard: {
    marginLeft: `${theme.spacing(1)} !important`,
    marginRight: `${theme.spacing(1)} !important`,
  },
  rootContentRow: {
    display: "flex",
    flexDirection: "row",
    padding: theme.spacing(3, 2),
  },
  paper: {
    width: "100%",
    backgroundColor: `${LIGHT_GREY} !important`,
    padding: theme.spacing(1, 3),
  },
  paperCharts: {
    width: "50%",
    backgroundColor: `${LIGHT_GREY} !important`,
    padding: theme.spacing(1, 3),
  },
  paperCreatedDay: {
    backgroundColor: `${LIGHT_GREY} !important`,
    padding: theme.spacing(1, 3),
  },
  btnPutList: {
    marginLeft: `${theme.spacing(2)} !important`,
  },
  textCoast: { display: "flex", alignItems: "baseline" },
  inputPhone: { marginLeft: `${theme.spacing(2)} !important` },
  drawer: { padding: theme.spacing(2, 2), width: 450 },
  drawerAction: {
    width: "100%",
    bottom: theme.spacing(1),
    right: 0,
    backgroundColor: "#FFF",
    position: "sticky",
    padding: theme.spacing(1),
    borderTopWidth: 1,
    borderTopStyle: "solid",
    borderTopColor: LIGHT_GREY,
    zIndex: 2,
  },
  chip: {
    padding: "2px 8px 2px 8px",
    border: `2px solid ${LIGHT_BLACK}`,
    borderRadius: 15,
    margin: 3,
    fontSize: 12,
  },
  rootInsightParams: {
    overflow: "scroll",
    paddingBottom: "1vh",
    paddingTop: "1vh",
  },
}));
